import { render } from "./Help.vue?vue&type=template&id=634a1115&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=634a1115&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634a1115"]])

export default __exports__